import { TaxonomyModalFooter } from "./TaxonomyModalFooter.component";

export { TaxonomyModalFooter };
